import React, { useState, useEffect, useRef } from 'react';
import Button, { BUTTON_VARIANTS } from '../components2/UI/Button/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinus, faPlus } from '@fortawesome/pro-solid-svg-icons';

const ViewMore = ({ children, limit = 10 }) => {
    const [showButton, setShowButton] = useState(false);
    const [toggleViewMore, setToggleViewMore] = useState(false);
    const viewMoreRef = useRef(null);

    useEffect(() => {
        const componentHeight = viewMoreRef.current.clientHeight;
        setShowButton(componentHeight >= limit);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [children]);

    return (
        <>
            <div ref={viewMoreRef} style={toggleViewMore 
                ? {} 
                : {
                    maxHeight: limit + 'px',
                    overflow: 'hidden',
                }
            }>
                {children}
            </div>
            {showButton && (
                <Button style={{ marginTop: '8px' }} small variant={BUTTON_VARIANTS.DARKEN} onClick={() => setToggleViewMore(!toggleViewMore)}>
                    <FontAwesomeIcon icon={toggleViewMore ? faMinus : faPlus} /> Voir {toggleViewMore ? 'moins' : 'plus'}
                </Button>
            )}
        </>
    );
};

export default ViewMore;